export default {
  flashSalesDiscount: {
    id: 'product_card_price_flash_sales_discount',
    defaultMessage: 'After {discount} applied at checkout',
  },
  flashSalesDiscountTooltip: {
    id: 'product_card_flash_sales_tooltip',
    defaultMessage:
      'This deal is limited to one per purchase and is not stackable with other promotions. The item is sold by a third-party with Back Market providing the promo code, not the seller.',
  },
} as const
